import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { supabase } from "../supabase";

const Values = () => {
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingValue, setEditingValue] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchValues();
  }, []);

  const fetchValues = async () => {
    try {
      const { data, error } = await supabase.from("values").select("*");
      if (error) throw error;
      setValues(data);
    } catch (error) {
      message.error("Error fetching values");
    } finally {
      setLoading(false);
    }
  };

  const showModal = (value = null) => {
    setEditingValue(value);
    setIsModalVisible(true);
    if (value) {
      form.setFieldsValue(value);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      if (editingValue) {
        const { error } = await supabase
          .from("values")
          .update(values)
          .eq("id", editingValue.id);
        if (error) throw error;
        message.success("Value updated successfully");
      } else {
        const { error } = await supabase.from("values").insert([values]);
        if (error) throw error;
        message.success("Value added successfully");
      }
      fetchValues();
      handleCancel();
    } catch (error) {
      message.error("Error saving value");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => showModal(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => showModal()}
        style={{ marginBottom: 16 }}
      >
        Add Value
      </Button>
      <Table columns={columns} dataSource={values} loading={loading} rowKey="id" />
      <Modal
        title={editingValue ? "Edit Value" : "Add Value"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please input the name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please input the description!" }]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Values;
